import {CreateProductMultiStepForm} from "../multi-step-form";

export function CreateProductMultiStepFormWrapper() {
  return <CreateProductMultiStepForm />;
}
